import React from "react";

import { cn } from "../../lib/utils";

// Barra de abas padrão das telas de gestão. No mobile ela rola na horizontal
// em vez de espremer os rótulos, e a aba ativa entra na visão sozinha.
const PageTabs = ({ abas, atual, onChange, className }) => {
  const refDaAtiva = React.useRef(null);

  React.useEffect(() => {
    refDaAtiva.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }, [atual]);

  return (
    <div
      role="tablist"
      aria-label="Seções da página"
      className={cn(
        // scrollbar-none deixa o gesto de rolar sem a barra à vista.
        "flex gap-1 overflow-x-auto border-b px-2 scrollbar-none [&::-webkit-scrollbar]:hidden",
        className
      )}
    >
      {abas.map((aba) => {
        const ativa = atual === aba.value;

        return (
          <button
            key={aba.value}
            ref={ativa ? refDaAtiva : undefined}
            type="button"
            role="tab"
            aria-selected={ativa}
            onClick={() => onChange(aba.value)}
            className={cn(
              "relative flex shrink-0 items-center gap-1.5 px-3 py-2.5 text-sm font-medium transition-colors",
              ativa
                ? "text-primary"
                : "text-muted-foreground hover:text-foreground"
            )}
          >
            {aba.icone && <aba.icone className="h-4 w-4 shrink-0" />}
            <span className="whitespace-nowrap">{aba.rotulo}</span>

            {aba.contador > 0 && (
              <span
                className={cn(
                  "flex h-[18px] min-w-[18px] items-center justify-center rounded-full px-1 text-[10px] font-semibold tabular-nums",
                  ativa
                    ? "bg-primary text-primary-foreground"
                    : "bg-muted text-muted-foreground"
                )}
              >
                {aba.contador}
              </span>
            )}

            {ativa && (
              <span className="absolute inset-x-2 bottom-0 h-0.5 rounded-full bg-primary" />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default PageTabs;
